import React from 'react'
import { connect } from 'react-redux'
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, TextField, IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { closeUpdateProfileModal } from '../../actions/metaAction'
import { updateProfile } from '../../actions/userAction'

const DisplayingErrorMessagesSchema = Yup.object().shape({
    full_name: Yup.string().trim().min(2).max(40).nullable().required('Required'),
    email: Yup.string().trim().email("Invalid format").nullable().required('Required'),
});

const useStyles = makeStyles((theme) => ({
    link: {
        color: theme.palette.primary.main
    },
    marginTop: {
        marginTop: theme.spacing(2)
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'no-wrap'
    }

}));


const UpdateProfile = (props) => {

    const classes = useStyles()

    return (
        <Dialog
            fullWidth
            maxWidth="xs"
            open={props.isUpdateProfileModalOpen}
            onClose={props.closeUpdateProfileModal}
            aria-labelledby="Update Profile Pop Up"
            aria-describedby="Update Profile Pop Up"
        >
            <DialogTitle>
                <div className={classes.row}>
                    <Typography component="p" variant="body1" color="primary">
                        <strong>Update Profile</strong>
                    </Typography>

                    <IconButton onClick={props.closeUpdateProfileModal} color="primary">
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogTitle>

            <DialogContent>
                <Grid container>
                    <Grid item xs={12}>
                        <Formik
                            initialValues={{
                                full_name: props.full_name,
                                email: props.email,
                            }}
                            enableReinitialize={true}
                            validationSchema={DisplayingErrorMessagesSchema}
                            onSubmit={values => {
                                props.updateProfile(values)
                            }}
                        >
                            {({ errors, touched }) => (
                                <Form>
                                    <div style={{ marginBottom: "2rem" }}>
                                        <Field name="full_name" type="text">
                                            {({
                                                field, // { name, value, onChange, onBlur }
                                                form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                                                meta,
                                            }) => (
                                                    <div>
                                                        <TextField {...field} label="Full Name" fullWidth size="small" variant="outlined" />
                                                        {meta.touched && meta.error && <div className="error">{meta.error}</div>}
                                                    </div>
                                                )}
                                        </Field>
                                    </div>
                                    <div style={{ marginBottom: "2rem" }}>
                                        <Field name="email" type="text">
                                            {({
                                                field, // { name, value, onChange, onBlur }
                                                form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                                                meta,
                                            }) => (
                                                    <div>
                                                        <TextField {...field} label="Email" fullWidth size="small" variant="outlined" />
                                                        {meta.touched && meta.error && <div className="error">{meta.error}</div>}
                                                    </div>
                                                )}
                                        </Field>
                                    </div>


                                    <Button type="submit" fullWidth variant="contained" color="secondary">Update</Button>

                                </Form>
                            )}
                        </Formik>
                    </Grid>
                </Grid>

            </DialogContent>

            <DialogActions>

            </DialogActions>
        </Dialog>
    )

}

const mapStateToProps = (state) => {
    const { isUpdateProfileModalOpen } = state.meta
    const { full_name, email } = state.user.profile

    return {
        full_name,
        email,
        isUpdateProfileModalOpen
    }
}

export default connect(mapStateToProps, { updateProfile, closeUpdateProfileModal })(UpdateProfile)